import { render, staticRenderFns } from "./QandA.vue?vue&type=template&id=409d4c0a&"
import script from "./QandA.vue?vue&type=script&lang=js&"
export * from "./QandA.vue?vue&type=script&lang=js&"
import style0 from "./QandA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports